import { useBalances } from "@/api/balances"
import Loader from "@/components/layout/loader"
import BalanceCard from "./balance.card"

export default function Balance() {
  const { currentBalance, totalPayments, totalWithdrawals, isLoading } =
    useBalances()

  if (isLoading) return <Loader message="Loading balances" />

  return (
    <BalanceCard
      currentBalance={currentBalance}
      totalPayments={totalPayments}
      totalWithdrawals={totalWithdrawals}
    />
  )
}
